<template>
  <div class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Lab Identification</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Name" :label-cols="2">
                <b-form-input
                  v-model="form_data.name"
                  id="name"
                  type="text"
                  autocomplete="name"
                  placeholder="Laboratory Name"
                />
              </b-form-group>
              <b-form-group label="Code" :label-cols="2">
                <b-form-input
                  v-model="form_data.code"
                  id="code"
                  type="text"
                  autocomplete="code"
                  placeholder="Laboratory Code"                  
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  id="description"
                  autocomplete="description"
                  placeholder="Laboratory Description"                  
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Contact Information</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Phone" :label-cols="2">
                <b-form-input
                  v-model="form_data.phone"
                  id="phone"
                  type="text"
                  autocomplete="phone"
                  placeholder="Phone #"                  
                />
              </b-form-group>
              <b-form-group label="Fax" :label-cols="2">
                <b-form-input
                  v-model="form_data.fax"
                  id="fax"
                  type="text"
                  autocomplete="fax"
                  placeholder="Fax #"                  
                />
              </b-form-group>
              <b-form-group label="Email" :label-cols="2">
                <b-form-input
                  v-model="form_data.email"
                  id="email"
                  type="text"
                  autocomplete="email"
                  placeholder="Email Address"                  
                />
              </b-form-group>
              <b-form-group label="Website" :label-cols="2">
                <b-form-input
                  v-model="form_data.website"
                  id="website"
                  type="text"
                  autocomplete="website"
                  placeholder="https://"                  
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Lab Location</span>
            </b-card-header>
            <div class="py-3 px-5">
              <address-form
                :form_data="form_data"
                @updateFormData="updateFormData"
              />
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Legal Information</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Legal Name" :label-cols="2">
                <b-form-input
                  v-model="form_data.legal_name"
                  id="legal_name"
                  type="text"
                  autocomplete="legal_name"
                  placeholder="Legal Name"                  
                />
              </b-form-group>
              <b-form-group label="GST Number" :label-cols="2">
                <b-form-input
                  v-model="form_data.gst_number"
                  id="gst_number"
                  type="text"
                  autocomplete="gst_number"
                  placeholder="GST Number"                  
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import AddressForm from "@/components/shared/form/AddressForm";
import LaboratoryCard from "@/components/lab/laboratory/LaboratoryCard";

export default {
  name: "LaboratoryForm",
  components: {
    AddressForm,
    LaboratoryCard
  },
  props: {
    laboratory: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      form_data: {
        name: null,
        code: null,
        description: null,
        phone: null,
        fax: null,
        email: null,
        website: null,
        address: null,
        address2: null,
        country: null,
        city: null,
        region: null,
        postal: null,
        legal_name: null,
        gst_number: null,
      }
    };
  },
  methods: {
    initFormData() {
      this.form_data = {
        ...this.form_data,
        ...this.laboratory.cloneAttributes(true, true, ["id"])
      }
    },
    updateFormData({ field, value }) {
      this.form_data[field] = value;
    },
    submitForm() {
      this.$emit("submit", this.form_data);
    },
  },
  created() {
    this.laboratory && this.initFormData();
  }
};
</script>
